// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2TdxC","buttons":"Footer_buttons__1EWFW"};